module.exports = __webpack_public_path__ + "static/media/cookie2.d6a3498e.png";